export const searchRoute = [
  // 全局搜索
  // {
  //   path: "/search",
  //   name: "search",
  //   component: () => import("@/zh-website/src/views/global-search/index2.vue")
  // },
  {
    path: "/home/search",
    name: "homeSearch",
    component: () => import("@/zh-website/src/views/global-search/index.vue"),
    meta: {
      keepAlive: true
    }
  },
];
